import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { servicedeskChannelsRoute } from '@jira/router-routes__servicedesk-channels-routes/src/servicedeskChannelsRoute.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { servicedeskChannelsEntryPoint } from '@jira/spa-apps__servicedesk-channels/src/servicedeskChannelsEntryPoint.entrypoint.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { ChannelsPageSkeleton } from '@jira/platform__skeletons/src/ui/servicedesk/channels/ChannelsPageSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

const CHANNELS_APP_NAME = 'servicedesk.channels';
const CHANNELS_PACKAGE_NAME = 'servicedeskChannels';

const servicedeskChannelsPageEntryPoint = createPageEntryPoint({
	main: servicedeskChannelsEntryPoint,
});

export const servicedeskChannelsRouteEntry: Route = createEntry(servicedeskChannelsRoute, () => ({
	group: 'servicedesk',
	layout: serviceProjectLayout,
	skeleton: expValEquals('jsmgrowth_259_improve_discovery_of_channels', 'isEnabled', true, false)
		? ChannelsPageSkeleton
		: undefined,

	navigation: {
		menuId: MenuIdProjects,
	},

	entryPoint() {
		// Gate-off path serves a 404 — Channels bundle is NOT downloaded when gate is off
		return expValEquals('jsmgrowth_259_improve_discovery_of_channels', 'isEnabled', true, false)
			? servicedeskChannelsPageEntryPoint
			: notFoundPageEntrypoint;
	},

	perfMetricKey: 'jsm-channels-page-load',

	meta: {
		reporting: {
			id: CHANNELS_APP_NAME,
			packageName: CHANNELS_PACKAGE_NAME,
			teamName: 'Sequoia',
		},
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getServicedeskPageContextResources(),
		staticProjectSidebarNavigationResource,
	],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
